/*!
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/bugtracker/bugtracker',['require','jquery','backbone','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var Backbone = require('backbone');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var Bugtracker = Marionette.Module.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    win: null,
    settings: { },
    radio: Backbone.Wreqr.radio.channel('global').vent,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    onStart: function(options)
    {
      this.settings = options.modules.bugtracker;

      if (!this.settings.enabled)
        return;

      //console.log('Bugtracker::start');

      this.win = null;
      this.winParams = 'height=250,width=560,scrollbars=yes';

      $(window).on('beforeunload', $.proxy(this.destroy, this));

      this.radio.on('page.changed', function(object)
      {
        this.track(object.page.get('id'), object.page.getViewType());
      }, this);
    },

    track: function(id, type)
    {
      if (!this.settings.enabled)
        return;

      var page = id;

      if (type)
        page += ' [' + type + ']';

      var params = this.settings.url + '?courseName=' + this.settings.projectName + '&page=' + page;

      if (this.win && !this.win.closed)
        this.win.location = params;
      else
        this.win = window.open(params, '_blank', this.winParams);
    },

    destroy: function()
    {
      if (this.win)
        this.win.close();
    }

  /*****************************************************************************************************************///}

  });

  return Bugtracker;

});

